import { BASE_URI } from '../config';

export const getAlbumArchiveSrc = (albumID: string): string => {
  return `${BASE_URI}/api/storage/download/album_archive/${albumID}`;
};
